import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { setOrigin } from '../../../actions/newBooking';
import { ORIGIN_REACT_MOBILE_APP } from '../../../constants/index';

export default () => {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(setOrigin(ORIGIN_REACT_MOBILE_APP));
  }, [dispatch]);
};
